// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AreaTile_wrapper__rU441","link":"AreaTile_link__R_drr","icon":"AreaTile_icon__DxCE_","name":"AreaTile_name__Ea_sC"};